/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { PRICE_LIST } from '../../urls'
import { useLoad } from '../../hooks/request'
import { useQueryParams } from '../../hooks/queryString'
import Button from '../../components/common/Button'
import { useModal } from '../../hooks/modal'
import Table from '../../components/common/Table'
import Layout from '../../components/Layout'
import PriceItem from './PriceItem'
import PriceCreate from './PriceCreate'
import SettingsTabs from "../../components/settings/SettingsTabs";

export default function Price() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const expense = useLoad(
        {
            url: PRICE_LIST,
            params: { page, ...params, ...searchParam },
        },
        [searchParam, page, params],
    )
    const productList = expense.response ? expense.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<PriceCreate expenseReport={expense} onCancel={() => setShowCreateModal()} />, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <SettingsTabs />
            <div className="">
                <div className="is-flex is-flex-direction-column">
                    <div className="level mb-4">
                        <div className="level-right">
                            <div className="level-item">
                                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4 mb-4">
                <Table
                    loading={expense.loading}
                    items={productList}
                    columns={{
                        index: '№',
                        date: '1 кВт учун (⚡)',
                        subcategory: '1 м³ учун (💧)',
                        status: '1 м³ учун (🔥)',
                        buttons: '',
                    }}
                    totalCount={expense.response ? expense.response.count : 0}
                    activePage={page}
                    onPageChange={setPage}
                    renderItem={(item, index) => <PriceItem expenseReport={expense} index={index} key={item.id} item={item} />}
                />
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
